"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadSegments = loadSegments;
exports.createSegment = createSegment;
exports.updateSegment = updateSegment;
exports.deleteSegment = deleteSegment;
exports.watchLoadSegments = watchLoadSegments;
exports.watchCreateSegment = watchCreateSegment;
exports.watchUpdateSegment = watchUpdateSegment;
exports.watchDeleteSegment = watchDeleteSegment;
exports["default"] = exports.segmentsSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _effects = require("redux-saga/effects");

var _utils = require("../../utils");

var _actions = _interopRequireDefault(require("./actions"));

var _selectors = require("./selectors");

var _marked = _regeneratorRuntime2.mark(loadSegments),
    _marked2 = _regeneratorRuntime2.mark(createSegment),
    _marked3 = _regeneratorRuntime2.mark(updateSegment),
    _marked4 = _regeneratorRuntime2.mark(deleteSegment),
    _marked5 = _regeneratorRuntime2.mark(watchLoadSegments),
    _marked6 = _regeneratorRuntime2.mark(watchCreateSegment),
    _marked7 = _regeneratorRuntime2.mark(watchUpdateSegment),
    _marked8 = _regeneratorRuntime2.mark(watchDeleteSegment);

function loadSegments(api, action) {
  var _action$payload, clientId, limit, skip, search, fetchMore, _yield$api$getSegment, data, meta, segmentsData, newData;

  return _regenerator["default"].wrap(function loadSegments$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.put)(_actions["default"].isLoading(true));

        case 3:
          _action$payload = action.payload, clientId = _action$payload.clientId, limit = _action$payload.limit, skip = _action$payload.skip, search = _action$payload.search, fetchMore = _action$payload.fetchMore;
          _context.next = 6;
          return api.getSegments({
            clientId: clientId,
            limit: limit,
            skip: skip,
            search: search
          }).then(function (p) {
            return p.request;
          });

        case 6:
          _yield$api$getSegment = _context.sent;
          data = _yield$api$getSegment.data;
          meta = _yield$api$getSegment.meta;
          _context.next = 11;
          return (0, _effects.select)(_selectors.segmentsDataSelector);

        case 11:
          segmentsData = _context.sent;
          newData = fetchMore ? [].concat((0, _toConsumableArray2["default"])(segmentsData), (0, _toConsumableArray2["default"])(data || [])) : data;
          _context.next = 15;
          return (0, _effects.put)(_actions["default"].loadSegmentsSuccess({
            data: newData,
            meta: meta
          }));

        case 15:
          _context.next = 17;
          return (0, _effects.put)(_actions["default"].isLoading(false));

        case 17:
          _context.next = 23;
          break;

        case 19:
          _context.prev = 19;
          _context.t0 = _context["catch"](0);
          _context.next = 23;
          return (0, _effects.put)(_actions["default"].loadSegmentsError());

        case 23:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 19]]);
}

function createSegment(api, action) {
  var _action$payload2, clientId, identifier, name, criteria;

  return _regenerator["default"].wrap(function createSegment$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _action$payload2 = action.payload, clientId = _action$payload2.clientId, identifier = _action$payload2.identifier, name = _action$payload2.name, criteria = _action$payload2.criteria;
          _context2.next = 4;
          return api.createSegment({
            clientId: clientId,
            identifier: identifier,
            name: name,
            criteria: criteria
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context2.next = 6;
          return (0, _effects.put)(_actions["default"].createSegmentSuccess());

        case 6:
          _context2.next = 12;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 12;
          return (0, _effects.put)(_actions["default"].createSegmentError());

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 8]]);
}

function updateSegment(api, action) {
  var _action$payload3, clientId, segmentId, identifier, name, criteria, updatedSegment;

  return _regenerator["default"].wrap(function updateSegment$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _action$payload3 = action.payload, clientId = _action$payload3.clientId, segmentId = _action$payload3.segmentId, identifier = _action$payload3.identifier, name = _action$payload3.name, criteria = _action$payload3.criteria;
          _context3.next = 4;
          return api.updateSegment({
            clientId: clientId,
            segmentId: segmentId,
            identifier: identifier,
            name: name,
            criteria: criteria
          }).then(function (p) {
            return p.request;
          });

        case 4:
          updatedSegment = _context3.sent;
          _context3.next = 7;
          return (0, _effects.put)(_actions["default"].updateSegmentSuccess(updatedSegment));

        case 7:
          _context3.next = 13;
          break;

        case 9:
          _context3.prev = 9;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 13;
          return (0, _effects.put)(_actions["default"].updateSegmentError());

        case 13:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 9]]);
}

function deleteSegment(api, action) {
  var _action$payload4, segmentId, clientId;

  return _regenerator["default"].wrap(function deleteSegment$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _action$payload4 = action.payload, segmentId = _action$payload4.segmentId, clientId = _action$payload4.clientId;
          _context4.next = 4;
          return api.deleteSegment({
            segmentId: segmentId,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context4.next = 6;
          return (0, _effects.put)(_actions["default"].deleteSegmentSuccess());

        case 6:
          _context4.next = 12;
          break;

        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 12;
          return (0, _effects.put)(_actions["default"].deleteSegmentError());

        case 12:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[0, 8]]);
}

function watchLoadSegments(api) {
  return _regenerator["default"].wrap(function watchLoadSegments$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadSegments), loadSegments, api);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function watchCreateSegment(api) {
  return _regenerator["default"].wrap(function watchCreateSegment$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].createSegment), createSegment, api);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function watchUpdateSegment(api) {
  return _regenerator["default"].wrap(function watchUpdateSegment$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].updateSegment), updateSegment, api);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function watchDeleteSegment(api) {
  return _regenerator["default"].wrap(function watchDeleteSegment$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].deleteSegment), deleteSegment, api);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

var segmentsSagas = function segmentsSagas(api) {
  return [(0, _effects.fork)(watchLoadSegments, api), (0, _effects.fork)(watchCreateSegment, api), (0, _effects.fork)(watchUpdateSegment, api), (0, _effects.fork)(watchDeleteSegment, api)];
};

exports.segmentsSagas = segmentsSagas;
var _default = segmentsSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map